import React from "react";
import Foreldre from "./Foreldre";
import icons from "../helpers/icons";
import {formatDate} from "../helpers/util";
import {Link} from 'react-router-dom';

const Forfedre = (props) => {
    const {hund, far, mor, labelHund, labelFar, labelMor} = props;

    const renderHund = () => {
        if (hund !== null) {
            return (
                <Link to={`/hund?id=${hund.hundId}`}>
                    <div className="dogweb-card active-card">
                        <div className="arrow">
                            <img className="icon" src={icons.arw} alt="" />
                        </div>

                        {
                            hund.tittel1 !== null &&
                            <p>
                                <label>
                                    <img className="icon score-black" src={icons.scoreWt} alt="" />
                                </label>
                                {hund.tittel1}
                            </p>
                        }

                        <h3>{hund.navn}</h3>
                        <p><span>FØDT:</span> {formatDate(hund.foedt)}</p>
                        { hund.farge && <p><span>FARVE:</span> {hund.farge}</p> }
                        <p><span>Reg.nr:</span> {hund.hundId}</p>
                        {
                            hund.opprinneligHundId !== null &&
                            <p><span>TIDLIGERE Reg.nr:</span> {hund.opprinneligHundId}</p>
                        }
                        <p><span>ID:</span> {hund.idnummere}</p>
                    </div>
                </Link>
            );
        } else {
            return (
                <div className="dogweb-card active-card">
                    Det er ikke registrert noen {labelHund}
                </div>
            );
        }
    };

    return (
        <div>
            {renderHund()}
            <Foreldre far={far} mor={mor} labelFar={labelFar} labelMor={labelMor} />

        </div>
    );
};

export default Forfedre;